export default "__VITE_ASSET__Dh2gC5ot__"